module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAMAAAB2iTwcAAAASFBMVEUAAADPz8/MzMzNzc3Ozs7Ozs7Nzc3MzMzNzc3Nzc3Nzc3MzMzOzs7MzMzNzc3MzMzMzMzMzMzOzs7Nzc3Ozs7JycnMzMy/v7/SxfqqAAAAGHRSTlMADlDCbtPHvaCUdmEhGd+0moJ8ZVgvHgyNIoWSAAAAP0lEQVQI1yXHRxIAIQwDQZm0xE2k//8UY3ToKaE+HTzl3swhpcOQf4V86iG9t5Ts1uhPjIRiXJxAsz8BSL6wC0BIAYEl3v4FAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/breadLeftImg.png
// module id = VfO6
// module chunks = 2